import RestService from '../services/rest';

async function getOrders(limit, skip, search, order = '', field = '', filter = '', initialDate = '', finalDate = '') {
  return RestService.getAuthenticated(
    `panel/purchases?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}&filter=${filter}&initialDate=${initialDate}&finalDate=${finalDate}`,
  );
}

async function getOrderProcess(id) {
  return RestService.getAuthenticated(`panel/purchases/orderProcess?id=${id}`);
}

async function getPurchaseItems(purchaseId) {
  return RestService.getAuthenticated(`panel/purchases/purchaseItem?purchaseId=${purchaseId}`);
}

async function cancelOrder(orderId) {
  return RestService.postAuthenticated(`purchases/cancel?purchase=${orderId}`);
}

async function downloadOrderCsv(initialDate, finalDate) {
  const response = await RestService.getAuthenticated(`panel/purchases/csv?initialDate=${initialDate}&finalDate=${finalDate}`);
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Pedidos-CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function downloadPendingOrders() {
  const response = await RestService.getAuthenticated('cart/approve/csv');
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'carrinhos-pendentes-aprovacao.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

export default {
  getOrders,
  cancelOrder,
  getOrderProcess,
  downloadOrderCsv,
  downloadPendingOrders,
  getPurchaseItems,
};
